/** Difficulty grows both between waves and as the current formation is thinned. */
export function invasionPressure(wave: number, remaining: number, initial: number) {
  const cleared = 1 - Math.max(0, Math.min(1, remaining / Math.max(1, initial)));
  return {
    marchSpeed: 52 + wave * 20 + cleared * 50,
    attackInterval: Math.max(.24, .88 - wave * .18 - cleared * .16),
    projectileSpeed: 205 + wave * 35,
    shooters: wave === 1 ? 2 : 3,
    descent: 16 + wave * 2,
  };
}

export function aimedVelocity(from: { x: number; y: number }, targetX: number, speed: number, angleOffset = 0): { vx: number; vy: number } {
  const angle = Math.atan2(targetX - from.x, 441 - from.y) + angleOffset;
  return { vx: Math.sin(angle) * speed, vy: Math.cos(angle) * speed };
}
